import React from "react";
import CreditNotes from "./CreditNoteLists/CreditNotes";

const SummaryCreditNotes = () => {
    return <CreditNotes status="summary" title="summary" link="summary-credit-notes"/>;
};

export default SummaryCreditNotes;
